import { Box } from "../../../../../../mads";
import { Text } from "../../../../../../mads/Text";
import { useI18n } from "../../../../../../shared/I18n";
import { SlideIn } from "../../../core/SlideIn";

import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  modalContent: {
    flexGrow: 0,
    paddingBottom: 48,
    paddingLeft: 24,
    paddingRight: 24,
  },
});

export type InfoPopupProps = {
  isOpen: boolean;
  onDismiss: () => void;
};

export function InfoPopup({ isOpen, onDismiss }: InfoPopupProps) {
  const gt = useI18n();

  return (
    <SlideIn
      isOpen={isOpen}
      onDismiss={onDismiss}
      title={
        <Text level={3} sx={{ color: colors.foreground.strong }}>
          {gt.gettext("Applicant insights")}
        </Text>
      }
      sx={{ backgroundColor: colors.background["[base]"] }}
    >
      <Box sx={styles.modalContent}>
        <Text level={3} sx={{ marginBottom: 32, color: colors.foreground["[base]"] }}>
          {gt.gettext("See how you compare to other people who have applied to this job.")}
        </Text>
        <Text level={3} sx={{ color: colors.foreground["[base]"] }}>
          {gt.gettext(
            "This is based on a comparison of qualifications from applicants' resumes and the job's qualifications.",
          )}
        </Text>
      </Box>
    </SlideIn>
  );
}
